/** Set from main.js so WorldManager can nudge the live background (video + glitchGL) without a circular import through main. */
let _manager = null;

export function setBackgroundManager(m) {
  _manager = m;
}

export function getBackgroundManager() {
  return _manager;
}
